/**
 * Regla común de los buscadores de la Plataforma (2026-10-28, decisión del usuario): lo escrito se parte en palabras y
 * un registro coincide si sus campos, juntos, tienen todas, en cualquier orden y sin distinguir mayúsculas ni tildes
 * ("garzon floresta" encuentra a "Mario Garzón" con su finca "Floresta"). Se busca en el navegador, sobre listas ya
 * cargadas: ningún buscador le pide nada al servidor.
 */

/** Texto para comparar: en minúsculas y sin tildes ("Garzón" y "garzon" quedan iguales). */
export function normalizarBusqueda(texto: string): string {
  return texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/** Palabras de lo escrito, ya normalizadas; vacía si no hay nada escrito. */
export function palabrasBusqueda(texto: string): string[] {
  return normalizarBusqueda(texto).split(/\s+/).filter((palabra) => palabra !== "");
}

/**
 * Si los campos, juntos, tienen todas las `palabras` (las de `palabrasBusqueda`). Sin palabras coincide todo: una caja
 * de búsqueda vacía no filtra. Los campos nulos se ignoran; los números (p. ej. el código de un GPS) se comparan como
 * texto.
 */
export function coincideBusqueda(palabras: string[], ...campos: (string | number | null | undefined)[]): boolean {
  if (palabras.length === 0) return true;
  const texto = normalizarBusqueda(campos.filter((campo) => campo != null).join(" "));
  return palabras.every((palabra) => texto.includes(palabra));
}
